import { BadgeAccessory, DropdownMenu } from '@octopus-do/octopus-storybook'
import { UserFriends } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useAuth } from '@/hooks'
import { getBadgeType } from '@/utils'

export const UserTeams: React.FC = () => {
  const { teams } = useAuth()

  return (
    <>
      {teams.map(({ id, name, teamPlan, expired }) => (
        <DropdownMenu.Link
          icon={UserFriends}
          key={id}
          title={name}
          to={`/dashboard/${id}`}
        >
          <BadgeAccessory type={getBadgeType(teamPlan, expired)} />
        </DropdownMenu.Link>
      ))}
    </>
  )
}
